import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './twoColumnTileLarge.module.css';


function TCTLItem(props) {

    let itemLink = (props.item.link) ? props.item.link : 'javascript:void(0);';
    let backgroundImage = (props.item.image) ? props.item.image.image.asset.url : '';

    return (
        <a href={itemLink} className={styles.itemWrap}>
            <div className={styles.itemBg}  style={{ backgroundImage : `url("${backgroundImage}")`}}></div>
            <div className={styles.itemContent}>
                <h3>{props.item.title}</h3>
                <PortableText blocks={props.item.desc} />
            </div>
        </a>
    );
}
  
export default TCTLItem;